import { render, staticRenderFns } from "./DetailBlock.vue?vue&type=template&id=affdad6c&scoped=true&"
import script from "./DetailBlock.vue?vue&type=script&lang=js&"
export * from "./DetailBlock.vue?vue&type=script&lang=js&"
import style0 from "./DetailBlock.vue?vue&type=style&index=0&id=affdad6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affdad6c",
  null
  
)

export default component.exports